import type { ComponentType } from 'react';
import { useHashRoute } from '../shell/use-current-section.ts';

export interface SubPage {
  readonly id: string;
  readonly title: string;
  readonly summary: string;
  readonly Component: ComponentType;
}

export function SubPages(props: {
  title: string;
  section: string;
  pages: readonly [SubPage, ...SubPage[]];
}) {
  const { path } = useHashRoute();
  const current = props.pages.find((page) => page.id === path[0]) ?? props.pages[0];
  return (
    <>
      <h1 id="page-title">{props.title}</h1>
      <nav className="tabs sub-pages" aria-label={props.title}>
        {props.pages.map((page) => (
          <a
            key={page.id}
            href={`#/${props.section}/${page.id}`}
            aria-current={page.id === current.id ? 'page' : undefined}
          >
            {page.title}
          </a>
        ))}
      </nav>
      <p className="summary">{current.summary}</p>
      <current.Component />
    </>
  );
}
